import { Button, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import { useTracker } from "../../hooks/useTracker";
import { ElementClickAction } from "../../lib/TrackingAdapter";

interface TeamInvitationSuccess {
  teamName: string;
}

const TeamInvitationSuccess: React.FC<TeamInvitationSuccess> = ({ teamName }) => {
  const navigation = useNavigation();
  const tracker = useTracker();

  return (
    <InfoPage
      variant="success"
      title={`Successfully joined ${teamName}`}
      description={`Open Shapr3D and check out your team\u2019s projects in Teamspace!`}
      primaryCTA={
        <Button
          onClick={() => {
            tracker.trackButtonClick({
              action: ElementClickAction.GO_TO_DOWNLOAD,
            });
            navigation.goToDownloadPage();
          }}
        >
          Download Shapr3D
        </Button>
      }
    />
  );
};

export default TeamInvitationSuccess;
